import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'any' })
export class VoiceToTextService {
  recognition: any;
  text: string = '';
  textChanged = new Subject<string>();
  started: boolean = false;
  isSupported: boolean = false;

  constructor() {
    const SpeechRecognition =
      (window as any).SpeechRecognition ||
      (window as any).webkitSpeechRecognition;
    this.isSupported = !!SpeechRecognition;

    if (this.isSupported) {
      this.recognition = new SpeechRecognition();
      this.recognition.interimResults = true;
      this.recognition.continuous = true;
      this.recognition.lang = 'it-IT';
      this.recognition.addEventListener('result', (event: any) => {
        const transcript = Array.from(event.results)
          .map((result: any) => result[0])
          .map((result: any) => result.transcript)
          .join('');
        this.text = transcript;
        this.textChanged.next(this.text);
      });
    }
  }

  start() {
    if (!this.isSupported) {
      throw new Error('Speech recognition is not supported in this browser.');
    }
    this.started = true;
    this.recognition.start();
    return this.textChanged.asObservable();
  }

  stop() {
    if (!this.isSupported) return;
    this.started = false;
    this.recognition.stop();
  }
}
